module.exports = "<div id=\"chartContainer\" style=\"height: 370px; width: 100%;\"></div>"


//////////////////
// WEBPACK FOOTER
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/woreports/charts.html
// module id = ../../../../../src/app/components/Purchase/woreports/charts.html
// module chunks = main